module.exports = __webpack_public_path__ + "static/media/report-sent.77aea19c.svg";